import tools from '../../../../assets/javascript/tools.js'
export default {
  columns: {
    createName: {
      label: '店员姓名',
      visible: true,
      width: 'auto',
      align: 'left',
    },
    createTime: {
      label: "提交时间",
      visible: true,
      formatDay: true,
      width: "auto",
      align: "left",
  },
    readStatus: {
      label: '读取状态',
      visible: true,
      width: '150',
      align: 'left',
    },
  }
}